import {
    ref, watch, computed, onMounted,
} from '@vue/composition-api'
import store from '@/store'
import { useToast } from 'vue-toastification/composition'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'

export default function useGrowersList() {
    const client = ref(JSON.parse(localStorage.getItem('userData')).client)

    const toast = useToast()
    const records = ref(null)

    const columns = ref([
        { key: 'number', label: 'Number', searchable: true },
        { key: 'length', label: 'Length', searchable: true },
        { key: 'width', label: 'Width', searchable: true },
        { key: 'tiers', label: 'Tiers', searchable: true },
        { key: 'slot', label: 'Slot', searchable: true },
        { key: 'status', label: 'Status', searchable: true },
        'actions',
    ])

    const grower_id = ref(null)

    const from = ref(0)
    const to = ref(0)
    const meta = ref({ from: 0, to: 0, total: 0 })
    const perPage = ref(10)
    const totalRecords = ref(0)
    const currentPage = ref(1)
    const perPageOptions = [5, 10, 25, 50, 100]
    const searchQuery = ref('')
    const sortBy = ref('updated_at')
    const isSortDirDesc = ref(true)

    const refetch = () => {
        records.value.refresh()
    }

    watch([grower_id, currentPage, perPage, searchQuery, sortBy, isSortDirDesc], () => {
        refetch()
    })

    const fetch = (ctx, callback) => {
        store
            .dispatch('cromis-grower/barns', {
                grower_id: grower_id.value,
                query: searchQuery.value,
                per_page: perPage.value,
                page: currentPage.value,
                sortBy: sortBy.value,
                sortDesc: isSortDirDesc.value,
            })
            .then(response => {
                const { barns, meta } = response.data

                meta.value = meta

                callback(barns)
                totalRecords.value = meta.value.total
                from.value = meta.value.from
                to.value = meta.value.to
            })
            .catch(() => {
                toast({
                    component: ToastificationContent,
                    props: {
                        title: 'Error fetching grower barns',
                        icon: 'AlertTriangleIcon',
                        variant: 'danger',
                    },
                })
            })
    }

    // *===============================================---*
    // *--------- UI ---------------------------------------*
    // *===============================================---*

    const resolveGrowerTypeVariant = society => {
        if (society !== null) return 'success'
        return 'primary'
    }

    const resolveStatusVariant = status => {
        if (status === 1) return 'success'
        if (status === 0) return 'secondary'
        return 'warning'
    }

    return {
        fetch,
        columns,
        perPage,
        currentPage,
        totalRecords,
        from,
        to,
        meta,
        perPageOptions,
        searchQuery,
        sortBy,
        isSortDirDesc,
        records,

        resolveGrowerTypeVariant,
        resolveStatusVariant,
        refetch,

        grower_id,
    }
}
